export const tmaisNfcesColumns = [
  { label: 'Ações', value: 'actions', className: 'w-10' },
  { label: 'Status', value: 'status', className: 'w-10' },
  { label: 'Processada por', value: 'uploaded_by_name' },
  { label: 'Estabelecimento', value: 'establishment' },
  { label: 'Valor Total', value: 'total_amount' },
  { label: 'Processada em', value: 'created_at' },
]
